import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import VideoPopup from '../../common/VideoPopup/VideoPopup';

import './PierTutorial.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "../../../redux/reducers/root";

import { pierMessageState } from '../../../redux/reducers/getPierMessageReducer/pierMessageReducer';
import { getPierMessage } from '../../../redux/actions/pierMessage/pierMessage';

export default function PierTutorial(): JSX.Element {
    const { t } = useTranslation('login');
    const [viewModal, setViewModal] = useState(false);
    const toggleModal = () => {
        setViewModal(!viewModal);
    };

    const [pierReqSent, setPierReqSent] = useState(false);
    
    const pierState = useSelector((state: RootState) => state.pierLinkTextReducer.pierMessage as pierMessageState);

    const isEnabled = pierState.tut_enabled === 1;
    const videoSrc = localStorage.getItem("prefLang") === "fr" ?"https://www.youtube.com/embed/J8QfjUlvP1w" : "https://www.youtube.com/embed/Gqzxx6C_8Pw";

    const dispatch = useDispatch();

    useEffect(() => {
        if (!pierState.loading && !pierReqSent) {
            dispatch(getPierMessage());
            setPierReqSent(true);
        }
    }, [dispatch, pierState, pierReqSent])


    function renderTutorial() {
        if (isEnabled) {
            return (<><div className="pier-tutorial-container">
                <div>
                    <span className='tut-heading'>
                        {t('pier-tut-heading') as string}
                    </span>
                    {t('pier-tut-content') as string}
                    <div>
                        <div className='ampv4-tut-img'>
                            <img src='images/Tutorial.png' alt="tutorial icon" onClick={toggleModal}/>
                        </div>
                        <h3 id="tut-icon-caption">
                            { t('pier-tut-caption') as string}
                        </h3>
                    </div>
                </div>
            </div>
            {viewModal && <VideoPopup 
            toggleModal={toggleModal} 
            videoSrc={videoSrc}
            title={"PIER Login Tutorial"} />}
            </>);
        }

        return (<></>); 
    } 

    return (renderTutorial());
}